<template>
  <v-flex md12 sm12 lg4>
    <v-card :style="styles" dark height="200px" v-on="$listeners">
      <v-card-title class="primary white--text">
        <v-icon large left>
          {{ icon }}
        </v-icon>
        <h4 class="category font-weight-light" v-text="title" />
      </v-card-title>

      <div class="font-weight-light pa-4" style="height: 70px;">
        <p class="font-weight-light" v-text="description" />
      </div>

      <v-divider class="mx-2" />
      <v-card-actions>
        <v-btn v-if="link" small color="grey darken-2" @click="newTab(link)">
          open
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      required: true
    },
    subIcon: {
      type: String,
      default: undefined
    },
    subIconColor: {
      type: String,
      default: undefined
    },
    subTextColor: {
      type: String,
      default: undefined
    },
    subText: {
      type: String,
      default: undefined
    },
    title: {
      type: String,
      default: undefined
    },
    description: {
      type: String,
      default: undefined
    },
    value: {
      type: String,
      default: undefined
    },
    smallValue: {
      type: String,
      default: undefined
    },
    link: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      styles: null
    };
  },
  methods: {
    newTab: function(link) {
      window.open(link, "_blank");
    }
  }
};
</script>

<style lang="scss">
.v-card--material-feature {
  display: flex;
  flex-wrap: wrap;
  position: relative;

  .v-offset {
    display: inline-block;
    flex: 0 1;
    margin-top: 0;
    margin-left: 0;
    margin-right: auto;
    margin-bottom: 0 !important;
    max-width: 100%;
    padding: 0 16px 0;
  }
  .v-card {
    border-radius: 4px;
    flex: 0 1 auto;
    height: 300px !important;
  }
  .v-card__title {
    color: black !important;
    background-color: #132339 !important;
  }
  .title-icon {
    background-color: #132339 !important;
  }
  .v-card__text {
    display: inline-block;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
  }
  .v-card__actions {
    flex: 1 0 100%;
  }
}
</style>
